import * as moment from 'moment';
import { QUICK_QUOTE_CONSTANTS } from './../../quick-quote/quick-quote.constants';
import { QuickQuoteService } from './../../quick-quote/services/quick-quote.service';
import { TravelPartyService } from './../../travel-party/services/travel-party.service';
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService(quickQuoteService, travelPartyService) {
        this.quickQuoteService = quickQuoteService;
        this.travelPartyService = travelPartyService;
        this.constants = QUICK_QUOTE_CONSTANTS;
        this.moment = moment;
    }
    /**
     * Creates and track an analytics data model getting all the analytics data
     * from the selected filters and the travel party service when the apply filters
     * function is called
     *
     * @returns analytics model for to be tracked
     */
    AnalyticsService.prototype.applyFiltersAnalyticsTrackLink = function () {
        var applyFiltersValue = this.concatFilterNamesByFilterId();
        var analyticsPartySize = this.travelPartyService.getAnalyticsPartySize();
        var analyticsApplyFiltersModel = this.createAnalyticsDataModelApplyFilters(applyFiltersValue, analyticsPartySize);
        return analyticsApplyFiltersModel;
    };
    /**
     * Creates and track an analytics data model getting all the analytics data
     * from the selected filters and the travel party service when the clear all filters
     * function is called
     *
     * @returns analytics model for to be tracked
     */
    AnalyticsService.prototype.clearFiltersAnalyticsTrackLink = function () {
        var analyticsClearFiltersModel = {
            trackLinkID: "" + this.constants.analytics.cruiseFiltersLink + this.constants.analytics.clearAllButtonLink
        };
        return analyticsClearFiltersModel;
    };
    /**
     * Merge all the filters names inside of string array separate by ';'
     * when isDateFilter parameter is true this array will be formatted like a date
     *
     * @param selectedFilter current filter selected
     * @param isDateFilter flag to know when the filter is a date filter
     * @returns filter names concatenated like a string
     */
    AnalyticsService.prototype.joinSelectedFilterNames = function (selectedFilter, isDateFilter) {
        var _this = this;
        if (isDateFilter === void 0) { isDateFilter = false; }
        var filtersMapped = [''];
        if (selectedFilter.length > 0) {
            if (isDateFilter) {
                filtersMapped = selectedFilter.map(function (filter) {
                    return _this.moment(_this.quickQuoteService.getFiltersData()[filter.id].name, 'YYYY-MM')
                        .format('MMMM-YY').toLowerCase();
                });
            }
            else {
                filtersMapped = selectedFilter.map(function (filter) {
                    return _this.quickQuoteService.getFiltersData()[filter.id].name;
                });
            }
        }
        return filtersMapped.join(';');
    };
    /**
     * Loop the selectedFilter from quickQuote service in order to get the names for each filter,
     * to be formatted and concatenated in a string value
     *
     * @return string with te concatenated names
     */
    AnalyticsService.prototype.concatFilterNamesByFilterId = function () {
        var _this = this;
        var moreFiltersConstants = this.constants.filters['more-filters'];
        var datesFilterNames = '';
        var destinationFilterNames = '';
        var filterNames = [];
        var nightFilterNames = '';
        var portsFilterNames = '';
        var shipFilterNames = '';
        var specialFilterNames = '';
        this.quickQuoteService.selectedFilters
            .forEach(function (selectedFilter, filterIndex) {
            switch (filterIndex) {
                case _this.constants.filters.date.renderOrder:
                    datesFilterNames += _this.joinSelectedFilterNames(selectedFilter, true);
                    break;
                case _this.constants.filters.destination.renderOrder:
                    destinationFilterNames += _this.joinSelectedFilterNames(selectedFilter);
                    break;
                case _this.constants.filters.city.renderOrder:
                    portsFilterNames += _this.joinSelectedFilterNames(selectedFilter);
                    break;
                case moreFiltersConstants.renderOrder:
                    selectedFilter
                        .forEach(function (moreFilterSelected) {
                        if (moreFilterSelected.length > 0) {
                            switch (moreFilterSelected[0].groupType) {
                                case moreFiltersConstants.groupKey.theme:
                                    specialFilterNames +=
                                        _this.joinSelectedFilterNames(moreFilterSelected);
                                    break;
                                case moreFiltersConstants.groupKey.night:
                                    nightFilterNames +=
                                        _this.joinSelectedFilterNames(moreFilterSelected);
                                    break;
                                case moreFiltersConstants.groupKey.ship:
                                    shipFilterNames +=
                                        _this.joinSelectedFilterNames(moreFilterSelected);
                                    break;
                            }
                        }
                    });
                    break;
            }
        });
        filterNames = [
            datesFilterNames,
            destinationFilterNames,
            nightFilterNames,
            portsFilterNames,
            shipFilterNames,
            specialFilterNames
        ];
        return this.concatAllFiltersApplied.apply(this, filterNames);
    };
    /**
     * Set the analytics base model with the complete data receive in the params
     * for the filters applied and the guest information
     *
     * @param applyFiltersValue complete string with the applied filters
     * @param analyticsPartySize total number of the guest formatted with adults and childs prefix
     * @returns analytics data model with the filter and guest info setted
     */
    AnalyticsService.prototype.createAnalyticsDataModelApplyFilters = function (applyFiltersValue, analyticsPartySize) {
        var analyticsApplyFiltersModel = this.createAnalyticsBaseModelToApplyFilters();
        applyFiltersValue += !applyFiltersValue ? '' : ',';
        applyFiltersValue +=
            "" + this.constants.analytics['travel-party'].travelPartyPrefix + analyticsPartySize + "," + this.constants.analytics['travel-party'].stateroomPrefix + this.travelPartyService.getStaterooms().length;
        analyticsApplyFiltersModel.facetsProgress[0].name = applyFiltersValue;
        analyticsApplyFiltersModel.bookingSearchPartySize = analyticsPartySize;
        analyticsApplyFiltersModel.bookingSearchNumRooms = this.travelPartyService.getStaterooms().length;
        return analyticsApplyFiltersModel;
    };
    /**
     * Creates a string calling the addFilterType function for each filter trype
     * and concatenating all the values retrieve for each call
     *
     * @param filterNamesParams string array with the applied filter for each filter type
     * @returns string value with all the filters applied
     */
    AnalyticsService.prototype.concatAllFiltersApplied = function () {
        var filterNamesParams = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            filterNamesParams[_i] = arguments[_i];
        }
        var datesFilterNames = filterNamesParams[0], destinationFilterNames = filterNamesParams[1], nightFilterNames = filterNamesParams[2], portsFilterNames = filterNamesParams[3], shipFilterNames = filterNamesParams[4], specialFilterNames = filterNamesParams[5];
        var applyFilterValue = '';
        applyFilterValue += this.addFilterTypeToStringFilterNames(datesFilterNames, this.constants.analytics.date.applyFilterPrefix, applyFilterValue);
        applyFilterValue += this.addFilterTypeToStringFilterNames(destinationFilterNames, this.constants.analytics.destination.applyFilterPrefix, applyFilterValue);
        applyFilterValue += this.addFilterTypeToStringFilterNames(nightFilterNames, this.constants.analytics['more-filters'].nightFilterPrefix, applyFilterValue);
        applyFilterValue += this.addFilterTypeToStringFilterNames(portsFilterNames, this.constants.analytics.city.applyFilterPrefix, applyFilterValue);
        applyFilterValue += this.addFilterTypeToStringFilterNames(shipFilterNames, this.constants.analytics['more-filters'].shipFilterPrefix, applyFilterValue);
        applyFilterValue += this.addFilterTypeToStringFilterNames(specialFilterNames, this.constants.analytics['more-filters'].specialFilterPrefix, applyFilterValue);
        return applyFilterValue;
    };
    /**
     * Creates a base analytics model for applied filter
     *
     * @returns AnalyticsDataModel object with the trackLinkID
     */
    AnalyticsService.prototype.createAnalyticsBaseModelToApplyFilters = function () {
        var analyticsApplyFiltersModel = {
            facetsProgress: [
                {
                    name: ''
                }
            ],
            trackLinkID: "" + this.constants.analytics.cruiseFiltersLink + this.constants.analytics.applyFiltersButtonLink
        };
        return analyticsApplyFiltersModel;
    };
    /**
     * Concat the param filter type at the filterNames param
     *
     * @param  filterNames string with the all the filters names applied
     * @param  filterType filter type of  the filterNames string
     * @param  applyFilterValue all the filters has been concatenated and typed
     * @returns filterType value concatenated with filterNames value
     */
    AnalyticsService.prototype.addFilterTypeToStringFilterNames = function (filterNames, filterType, applyFilterValue) {
        var filterNamesValue = '';
        if (filterNames) {
            filterNamesValue += applyFilterValue ? ',' : '';
            filterNamesValue += "" + filterType + filterNames;
        }
        return filterNamesValue;
    };
    return AnalyticsService;
}());
export { AnalyticsService };
